import React, { useEffect, useState } from 'react';
import { fetchAuthenticatedBlobUrl, isDirectMediaSrc } from '../../api/mediaUrl';

/**
 * Renders images stored on the private file API (designs, profiles, order docs).
 * Legacy base64 data URIs and external URLs are shown directly.
 */
export function AuthenticatedImage({ src, alt = '', className, fallback = null, ...props }) {
  const [displaySrc, setDisplaySrc] = useState('');
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setFailed(false);

    const trimmed = String(src || '').trim();
    if (!trimmed) {
      setDisplaySrc('');
      return undefined;
    }
    if (isDirectMediaSrc(trimmed)) {
      setDisplaySrc(trimmed);
      return undefined;
    }

    fetchAuthenticatedBlobUrl(trimmed)
      .then((blobUrl) => {
        if (!cancelled) {
          setDisplaySrc(blobUrl);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setDisplaySrc('');
          setFailed(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [src]);

  if (!displaySrc) {
    return failed ? fallback : fallback;
  }

  return <img src={displaySrc} alt={alt} className={className} {...props} />;
}
